<template>
    <SliderRow
        :id="id"
        :label="$t(fieldConfig.label)"
        :value.sync="fieldValue"
        @update:value="syncChange"
    />
</template>

<script>
import SliderRow from '../components/SliderRow.vue';
import { FieldItemMixin } from './mixins';

export default {
    components: {
        SliderRow,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'q_perc_identity',
        },
    },
};
</script>
